var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Collapse as OriginalCollapseIcon } from '@class-ui/icons/dist/Collapse';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Fab from '@mui/material/Fab';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
const OuterContainer = styled(Box) `
    position: relative;
    z-index: 1;
`;
const Container = styled(Box) `
    position: relative;
    background-color: ${(props) => props.theme.palette.background.secondary}};
    padding: 12px 12px 18px 12px;
    height: 225px;
    width: 100%;
`;
const CollapseButton = styled(Fab) `
    position: absolute;
    bottom: -20px;
    right: 8px;
`;
const CollapseIcon = styled(OriginalCollapseIcon) `
    transform: rotate(90deg);
`;
const ExpandIcon = styled(OriginalCollapseIcon) `
    transform: rotate(270deg);
`;
export const FrontOfRoom = (props) => {
    const { outerContainerProps, unmountChildren = true, collapseProps, children, texts, collapsed: defaultCollapsed = false, onCollapseChange } = props, other = __rest(props, ["outerContainerProps", "unmountChildren", "collapseProps", "children", "texts", "collapsed", "onCollapseChange"]);
    const [collapsed, setCollapsed] = useState(defaultCollapsed);
    // This makes the animation a little nicer by unmounting the content _after_ the collapse animation is done
    const [fullyCollapsed, setFullyCollapsed] = useState(collapsed);
    const toggleCollapse = () => {
        const newState = !collapsed;
        setCollapsed(newState);
        onCollapseChange === null || onCollapseChange === void 0 ? void 0 : onCollapseChange(newState);
    };
    const shouldUnmount = fullyCollapsed && unmountChildren;
    return (_jsxs(OuterContainer, Object.assign({}, outerContainerProps, { children: [_jsx(Collapse, Object.assign({ in: !collapsed, collapsedSize: 24 }, collapseProps, { 
                // We can't use unmountOnExit because it makes positioning the expand button difficult (collapsedSize doesn't work)
                onEnter: (...args) => {
                    var _a;
                    setFullyCollapsed(false);
                    (_a = collapseProps === null || collapseProps === void 0 ? void 0 : collapseProps.onEnter) === null || _a === void 0 ? void 0 : _a.call(collapseProps, ...args);
                }, onExited: (...args) => {
                    var _a;
                    setFullyCollapsed(true);
                    (_a = collapseProps === null || collapseProps === void 0 ? void 0 : collapseProps.onExited) === null || _a === void 0 ? void 0 : _a.call(collapseProps, ...args);
                }, children: _jsx(Container, Object.assign({}, other, { children: !shouldUnmount && children })) })), _jsx(Tooltip, { title: collapsed ? texts.expand : texts.collapse, children: _jsx(CollapseButton, { size: 'small', onClick: toggleCollapse, "aria-label": collapsed ? texts.expand : texts.collapse, children: collapsed ? _jsx(ExpandIcon, {}) : _jsx(CollapseIcon, {}) }) })] })));
};
